import React from 'react'
import { LuChevronDown } from '@react-icons/all-files/lu/LuChevronDown'
type Props = {
  expanded?: boolean
  onClick?: () => void
}
export default function ExpandToggle(props: Props): React.ReactElement<'div'> {
  const expanded = props.expanded || null
  return (
    <div
      className="e2-expand"
      data-expanded={expanded}
      onClick={
        props.onClick
          ? e => {
              e.stopPropagation()
              if (props.onClick) props.onClick()
            }
          : undefined
      }
    >
      <LuChevronDown size={16} />
    </div>
  )
}
